import { RCCButton } from "react-common-components";
import styled, { css } from "styled-components";
import { IGrouperFilter } from "../../interface";

// eslint-disable-next-line import/prefer-default-export
export const GrouperFilterButton = styled(RCCButton)<IGrouperFilter>`
    padding: 2px 8px;
    margin: 5px 2px;
    ${(props) => props.isActive && css`filter: brightness(0.5);`}
`;
